import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Bulk POI-to-field-staff assignments (backend1: /poi/permissions)
export const POIAssignmentsApi = createApi({
	reducerPath: "POIAssignments",
	baseQuery: fetchBaseQuery({
		baseUrl: process.env.REACT_APP_BACKEND_URL,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem("token");
			if (token) {
				headers.set("Authorization", `Bearer ${token}`);
			}
			return headers;
		},
	}),
	tagTypes: ["UserPOIAssignments"],
	endpoints: (builder) => ({
		getUserPOIAssignments: builder.query({
			query: ({ userId }) => `poi/permissions/user/${userId}`,
			providesTags: (result, error, { userId }) => [
				{ type: "UserPOIAssignments", id: userId },
				"UserPOIAssignments",
			],
		}),
		// Multi-user variant: assignments for several field staff at once,
		// used by the bulk drawer to compute all/partial membership.
		getUsersPOIAssignments: builder.query({
			query: ({ userIds }) =>
				`poi/permissions/users?userIds=${[...userIds].sort((a, b) => a - b).join(",")}`,
			providesTags: ["UserPOIAssignments"],
		}),
		bulkUpdatePOIAssignments: builder.mutation({
			query: (val) => ({
				url: `poi/permissions/bulk`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
			invalidatesTags: ["UserPOIAssignments"],
		}),
	}),
});

export const {
	useGetUserPOIAssignmentsQuery,
	useGetUsersPOIAssignmentsQuery,
	useBulkUpdatePOIAssignmentsMutation,
} = POIAssignmentsApi;
